import type { ComponentType } from 'react';

import type {
  PreferenceScope,
  UserPreferenceKey,
  UserPreferenceSubKey,
  UserPreferences,
} from '../types';
import ContingentWorkersEditor, {
  meta as contingentWorkersMeta,
} from './ContingentWorkersEditor';
import CurrencyEditor, { meta as currencyMeta } from './CurrencyEditor';
import DataAdjustmentsEditor, {
  meta as dataAdjustmentsMeta,
} from './DataAdjustmentsEditor';
import DefaultFiltersEditor, {
  meta as defaultFiltersMeta,
} from './DefaultFiltersEditor';
import EconomicImpactGeographyEditor, {
  meta as economicImpactGeographyMeta,
} from './EconomicImpactGeographyEditor';
import EconomicImpactIndustriesEditor, {
  meta as economicImpactIndustriesMeta,
} from './EconomicImpactIndustriesEditor';
import GeographyEditor, { meta as geographyMeta } from './GeographyEditor';
import PageOrderEditor, { meta as pageOrderMeta } from './PageOrderEditor';
import TaxonomiesEditor, { meta as taxonomiesMeta } from './TaxonomiesEditor';

export interface PreferenceMeta {
  id: UserPreferenceKey;
  label: string;
}

export type OnPreferenceUpdateCallback = (
  preference: UserPreferenceKey,
  value: UserPreferences[UserPreferenceKey],
  subKey?: UserPreferenceSubKey
) => void;

export type PreferenceEditorProps = {
  affectedScope: PreferenceScope;
  onPreferenceUpdate: OnPreferenceUpdateCallback;
  preferences: UserPreferences;
  diff?: (UserPreferenceKey | UserPreferenceSubKey)[];
};

export interface PreferenceEditorEntry {
  meta: PreferenceMeta;
  component: ComponentType<PreferenceEditorProps>;
}

export const preferenceEditors = [
  { meta: dataAdjustmentsMeta, component: DataAdjustmentsEditor },
  { meta: contingentWorkersMeta, component: ContingentWorkersEditor },
  { meta: defaultFiltersMeta, component: DefaultFiltersEditor },
  { meta: taxonomiesMeta, component: TaxonomiesEditor },
  { meta: currencyMeta, component: CurrencyEditor },
  { meta: geographyMeta, component: GeographyEditor },
  {
    meta: economicImpactIndustriesMeta,
    component: EconomicImpactIndustriesEditor,
  },
  {
    meta: economicImpactGeographyMeta,
    component: EconomicImpactGeographyEditor,
  },
  { meta: pageOrderMeta, component: PageOrderEditor },
] as const satisfies readonly PreferenceEditorEntry[];
